import React from 'react';
import {
    Container, TopText, Types, Type, Timer, Home, TypeTitle, TypeText, Cta,
} from './Cars.style'

const Cars = ({ setFormActive, content }) => {
    const { text, list1, list2, cta } = content;

    return <Container>
        <TopText>{!!text && text.text}</TopText>
        <Types>
            <Type>
                <Timer />
                <TypeTitle>{!!list1.title && list1.title.text}</TypeTitle>
                <TypeText>{!!list1.text && list1.text.text}</TypeText>
            </Type>
            <Type>
                <Home />
                <TypeTitle>{!!list2.title && list2.title.text}</TypeTitle>
                <TypeText>{!!list2.text && list2.text.text}</TypeText>
            </Type>
        </Types>
        <Cta onClick={() => setFormActive(true)}>{!!cta && cta.text}</Cta>
    </Container>;
};

export default Cars;

